<script lang="ts">
	import { ArrowUpToLine } from 'lucide-svelte';

	let y = $state(0);
</script>

<svelte:window bind:scrollY={y} />
<div class="fixed bottom-5 left-5 opacity-50 hover:opacity-100 z-50" class:hidden={y < 150}>
	<button class="rounded-full bg-two p-3" onclick={() => (y = 0)} aria-label="Scroll to top">
		<ArrowUpToLine size="24" class="text-slate-400 dark:text-slate-300" />
	</button>
</div>
